import React from "react";
import PropTypes from "prop-types";

const UncheckedIcon = ({ size = 16, color = "#242424" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 0C14.8807 0 16 1.11929 16 2.5V13.5C16 14.8807 14.8807 16 13.5 16H2.5C1.11929 16 0 14.8807 0 13.5V2.5C0 1.11929 1.11929 0 2.5 0H13.5ZM1.5 2.5C1.5 1.94772 1.94772 1.5 2.5 1.5H13.5C14.0523 1.5 14.5 1.94772 14.5 2.5V13.5C14.5 14.0523 14.0523 14.5 13.5 14.5H2.5C1.94772 14.5 1.5 14.0523 1.5 13.5V2.5Z"
      fill={color}
    />
  </svg>
);

UncheckedIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default UncheckedIcon;
